import { render, staticRenderFns } from "./AdminCompany.vue?vue&type=template&id=28e0c473&scoped=true&"
import script from "./AdminCompany.vue?vue&type=script&lang=js&"
export * from "./AdminCompany.vue?vue&type=script&lang=js&"
import style0 from "./AdminCompany.vue?vue&type=style&index=0&id=28e0c473&scoped=true&lang=css&"
import style1 from "@/assets/css/util.css?vue&type=style&index=1&id=28e0c473&scoped=true&lang=css&"
import style2 from "./AdminCompany.vue?vue&type=style&index=2&id=28e0c473&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e0c473",
  null
  
)

export default component.exports